<div class="flex flex-top">
    <payment-icon [method]="card?.data.type"
                  [style.fontSize.px]="24"
                  class="bg-col-w m-r-5 m-r-2-s m-r-2-m"></payment-icon>

    <div>
        <p class="p1 col-12"> **** **** **** {{ card?.data?.last_four }}</p>
        <p class="p1 col-12"
           [class.col-2]="card?.isExpired"> {{'Exp. %' | translate : card?.data?.expiry_date }}</p>
    </div>
</div>
